import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "e979a813-0b4e-4ca8-9706-9481f9126c63", content: "The stomach", options: {} },
  { id: "c224a72f-3d8a-4a90-96db-169dd45295c9", content: "Buccal cavity", options: {} },
  { id: "6483c301-5d58-4fba-9b3c-22c16d92fad0", content: "The vocal folds", options: {} },
  { id: "e7896fb5-b8a1-4886-a7d7-7f6c0748939b", content: "The tongue", options: {} },
  { id: "b8bde6fb-b35e-4d51-a76e-22093b6bfd4d", content: "Diphtongs", options: {} },
  { id: "a3a74ada-de08-4298-a722-e420776d29ca", content: "Monophtongs", options: {} },
];

export const task: Task = {
  id: "ffd6a32e-fa32-40cd-bdb6-f8847cce6d33",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["6483c301-5d58-4fba-9b3c-22c16d92fad0"],
};
